import { useState, useCallback, useMemo } from 'react';

/**
 * Hook for managing authentication modal state
 * Provides centralized modal control for all auth flows
 *
 * @returns {object} Modal state and control functions
 */
export function useAuthModal() {
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState(null);

  const openCreateAccount = useCallback((data) => {
    setModalData(data);
    setActiveModal('create-account');
  }, []);

  const openLogin = useCallback((data) => {
    setModalData(data);
    setActiveModal('login');
  }, []);

  const openForgotPassword = useCallback((data) => {
    setModalData(data);
    setActiveModal('forgot-password');
  }, []);

  const openUpgrade = useCallback((data) => {
    setModalData(data);
    setActiveModal('upgrade');
  }, []);

  const closeModal = useCallback(() => {
    setActiveModal(null);
    // Clear data after animation completes
    setTimeout(() => {
      setModalData(null);
    }, 300);
  }, []);

  const state = useMemo(
    () => ({
      activeModal,
      modalData,
      openCreateAccount,
      openLogin,
      openForgotPassword,
      openUpgrade,
      closeModal
    }),
    [
      activeModal,
      modalData,
      openCreateAccount,
      openLogin,
      openForgotPassword,
      openUpgrade,
      closeModal
    ]
  );

  return state;
}
